import React from 'react'
import { ToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'

export const NotificationPopup = () => {
  return (
    <>
      <ToastContainer
        autoClose={3000}
        closeOnClick
        pauseOnHover
        position="top-left"
        rtl={false}
      />
    </>
  )
}
